import React from 'react';
import PropTypes from 'prop-types';
import { COLLECTION_VIDEO_BANNER_IMAGE } from 'helpers/ImageHelper';
import { getVideoObjectImages, getVideoObjectImage } from 'helpers/VideoProcessorHelper';
import Badge from 'components/Badge';
import { Image as ImageComponent, PlayButton } from 'components/Tile/components';
import LockIcon from '../LockIcon';
import ProgressBar from '../ProgressBar';
import Style from './BannerImage.module.scss';

const BannerImage = props => {
  const { breakpoint, isAuthenticated, onVideoImageClick, video } = props;
  const { images } = video;
  const imageObj = getVideoObjectImages({ images, defaultImage: 'seriesList' });
  const image = getVideoObjectImage({ image: imageObj });
  if (!image) return null;

  return (
    <div className={Style.imageContainer} onClick={onVideoImageClick}>
      <ImageComponent
        breakpoint={breakpoint}
        imageType={COLLECTION_VIDEO_BANNER_IMAGE}
        src={image}
        theme={Style}
      >
        <PlayButton theme={Style} thinIcon />
        <Badge badge="live" theme={Style} />
        <ProgressBar theme={Style} video={video} />
        {!isAuthenticated && <LockIcon Style={Style} />}
      </ImageComponent>
    </div>
  );
};

export default BannerImage;

BannerImage.propTypes = {
  breakpoint: PropTypes.string.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  onVideoImageClick: PropTypes.func.isRequired,
  video: PropTypes.shape({}).isRequired,
};
